export const primitiveRadius = {
	sm: '5px',
	md: '8px',
	lg: '10px',
	xl: '15px',
	full: '9999px',
} as const;

export const radius = {
	large: primitiveRadius.lg,
	normal: primitiveRadius.sm,
} as const;
